<template>
    <section class="container-fluid my-4">
        <h4 class="my-4">Relatório de <strong>Acompanhamento de Envio</strong></h4>

        <form @submit.prevent="generateXLSX">

            <div class="row">

                <div class="form-group col-md-6">

                    <div class="row">
                        <div class="col-md-6">
                            <div class="mb-3">
                                <SearchableSelect
                                    v-model="team_id"
                                    :options="teams"
                                    item-text="name"
                                    item-value="id"
                                    label="Turma (Opcional)"
                                    placeholder="-- Todas as turmas --"
                                />
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-6">
                            <div class="mb-3">
                                <label for="start_date" class="form-label">Data Inicial (Opcional)</label>
                                <input
                                    type="date"
                                    name="start_date"
                                    class="form-control"
                                    v-model="start_date"
                                />
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="mb-3">
                                <label for="end_date" class="form-label">Data Final (Opcional)</label>
                                <input
                                    type="date"
                                    name="end_date"
                                    class="form-control"
                                    v-model="end_date"
                                />
                            </div>
                        </div>
                    </div>

                    <div v-if="!loading" class="form-group text-center my-2">
                        <button type="submit" class="btn btn-success btn-sm mx-2 text-uppercase">
                            Gerar
                        </button>
                        <button type="reset" class="btn btn-secondary btn-sm text-uppercase" @click="resetForm">
                            Limpar
                        </button>
                    </div>

                    <LoadingPage v-else />

                </div>

            </div>

        </form>

        <button class="btn btn-sm btn-secondary" @click="$router.go(-1)">
            VOLTAR
        </button>
    </section>
</template>

<script>
import api from "@/services";
import LoadingPage from "@/components/LoadingPage.vue";
import SearchableSelect from "@/components/SearchableSelect.vue";

export default {
    name: "ShipmentTrackingReport",
    components: {
        LoadingPage,
        SearchableSelect,
    },
    data() {
        return {
            team_id: "",
            start_date: "",
            end_date: "",
            teams: [],
            loading: false,
        };
    },
    methods: {
        async getTeams() {
            await api.get(`/teams?page=0&perPage=99999&sortBy=name&forPagination=1`).then((res) => {
                this.teams = res.data.data;
            });
        },
        async generateXLSX() {
            try {
                this.loading = true;

                // Construir query string com filtros
                let queryParams = [];
                
                if (this.team_id) {
                    queryParams.push(`team_id=${this.team_id}`);
                }
                
                if (this.start_date) {
                    queryParams.push(`start_date=${this.start_date}`);
                }
                
                if (this.end_date) {
                    queryParams.push(`end_date=${this.end_date}`);
                }

                const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';

                await api
                    .get(`/exports/shipment-tracking-report${queryString}`, {
                        responseType: "blob",
                    })
                    .then((response) => {
                        const blob = new Blob(
                            [response.data],
                            { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64," }
                        );

                        const a = document.createElement("a");
                        a.href = URL.createObjectURL(blob);
                        a.download = `AcompanhamentoEnvio_${new Date().getTime()}`;
                        a.click();
                    });

            } catch (error) {
                if (error.response && error.response.data) {
                    // Tentar ler a mensagem de erro do blob
                    const reader = new FileReader();
                    reader.onload = () => {
                        try {
                            const errorData = JSON.parse(reader.result);
                            Toast.fire('Erro', errorData.error || error.message, "error");
                        } catch {
                            Toast.fire('Erro', error.message, "error");
                        }
                    };
                    reader.readAsText(error.response.data);
                } else {
                    Toast.fire('Erro', error.message, "error");
                }
            }
            this.loading = false;
        },
        resetForm() {
            this.team_id = "";
            this.start_date = "";
            this.end_date = "";
        }
    },
    mounted() {
        this.getTeams();
    },
};
</script>

<style scoped></style>
